module.exports = __webpack_public_path__ + "static/media/gatsby.5375943f.svg";